import up from '../../assets/img/up.svg'
import NivelUsuario from '../NivelUsuario'
import { get } from '../../services/api'
import { useEffect } from 'react'
import { useState } from 'react'


function DesempenhoGeralUsuario({ idVendedor, changeMesAno, changeVendedor, pontuacaoRealizadaTotal, pontuacaoProjetadaTotal }) {

    const [pontuacaoGeral, setPontuacaoGeral] = useState(null);
    const [pontuacaoRealizada, setPontuacaoRealizada] = useState(0);
    const [pontuacaoProjetada, setPontuacaoProjetada] = useState(0);
    const [nivelRealizado, setNivelRealizado] = useState('E');
    const [nivelProjetado, setNivelProjetado] = useState('E');

    useEffect(() => {
        limparDados();
        getPontuacaoGeral();
    }, [idVendedor]);

    useEffect(() => {
        setPontuacaoRealizada(pontuacaoRealizadaTotal);
        calcularNivelGeral();
    }, [pontuacaoRealizadaTotal]);

    useEffect(() => {
        setPontuacaoProjetada(pontuacaoProjetadaTotal);
        calcularNivelGeral();
    }, [pontuacaoProjetadaTotal]);

    useEffect(() => {
        limparDados();
    }, [changeMesAno]);

    useEffect(() => {
        limparDados();
    }, [changeVendedor]);

    async function getPontuacaoGeral() {
        try {
            const pontuacoes = await get('/metas/pontuacaogeral');
            setPontuacaoGeral(pontuacoes);
        } catch (error) {
            if (error.response) {
                console.error('Erro na resposta do servidor:', error.response.data);
                setPontuacaoGeral([]);
            } else if (error.request) {
                console.error('Sem resposta do servidor:', error.request);
                setPontuacaoGeral([]);
            } else {
                console.error('Erro durante a configuração da requisição:', error.message);
                setPontuacaoGeral([]);
            }
        }
    }

    function limparDados() {
        setPontuacaoProjetada(0);
        setPontuacaoRealizada(0);
        setNivelRealizado('E');
        setNivelProjetado('E');
    }

    function formataNivelLowerCase(nivel = 'E') {
        const nivelFormatado = nivel ? nivel.toLowerCase() : 'e';
        return nivelFormatado;
    }

    function calcularNivelGeral() {
        try {
            let nivelRealizado = 'E';
            let nivelProjetado = 'E';

            if (pontuacaoGeral && pontuacaoGeral.length > 0) {
                for (const p of pontuacaoGeral) {
                    if (pontuacaoRealizadaTotal >= p.pontuacao_minima && pontuacaoRealizadaTotal <= p.pontuacao_maxima) {
                        nivelRealizado = p.nivel;
                    }
                    if (pontuacaoProjetadaTotal >= p.pontuacao_minima && pontuacaoProjetadaTotal <= p.pontuacao_maxima) {
                        nivelProjetado = p.nivel;
                    }
                }

                // Caso a pontuação seja maior que o maior limite, retorne o nível de maior pontuação
                if (pontuacaoRealizadaTotal > pontuacaoGeral[pontuacaoGeral.length - 1].pontuacao_maxima) {
                    nivelRealizado = pontuacaoGeral[pontuacaoGeral.length - 1].nivel;
                }
                if (pontuacaoProjetadaTotal > pontuacaoGeral[pontuacaoGeral.length - 1].pontuacao_maxima) {
                    nivelProjetado = pontuacaoGeral[pontuacaoGeral.length - 1].nivel;
                }
            }

            setNivelRealizado(nivelRealizado);
            setNivelProjetado(nivelProjetado);
        } catch (error) {
            limparDados();
            if (error.response) {
                console.error('Erro na resposta do servidor:', error.response.data);
            } else if (error.request) {
                console.error('Sem resposta do servidor:', error.request);
            } else {
                console.error('Erro durante a configuração da requisição:', error.message);
            }
        }
    }

    return (
        <div>
            <div className="text-center text-white font-poppins nivelshow:mb-16">
                <h2 className="font-semibold text-3xl md:text-[42px] mb-4">Quer saber como melhorar seu desempenho?</h2>
                <h3 className="font-normal text-xl md:text-2xl">Clique em cada animal, e saiba mais detalhes</h3>
            </div>

            <div className="flex justify-center">
                <div className="mr-4">
                    <NivelUsuario tipo="Realizado" nivel={nivelRealizado} pontos={`${pontuacaoRealizada} pontos`} />
                </div>
                <div>
                    <NivelUsuario tipo="Projetado" nivel={nivelProjetado} pontos={`${pontuacaoProjetada} pontos`} />
                </div>
            </div>
            {!Array.isArray(pontuacaoGeral) && (
                <div className="text-center text-white font-poppins nivelshow:mb-16">
                    <h3 className="font-normal text-xl md:text-2xl">Sistema Indisponível, tente novamente mais tarde!</h3>
                </div>
            )}

            <div className="grid grid-cols-3 md:grid-cols-5 w-full lg:w-[80%] mx-auto text-center font-mulish text-white text-lg md:text-xl lg:text-2xl font-bold">

                <div className="grid grid-cols-none grid-rows-5 md:grid-rows-none md:grid-cols-5 md:col-span-5">
                    {Array.isArray(pontuacaoGeral) ? (pontuacaoGeral.map((pontuacao, index) => (
                        <div key={index} className="flex items-center justify-center flex-col gap-1 md:pb-1">
                            <p className="leading-none">{pontuacao.pontuacao_minima}-{pontuacao.pontuacao_maxima} pontos</p>
                            <p className="font-poppins text-white text-base font-semibold">(Nível {pontuacao.nivel})</p>
                        </div>
                    ))

                    ) : (
                        <>
                            <div className="flex items-center justify-center flex-col gap-1 md:pb-1 order-5 md:order-1">

                                <p className="font-poppins text-white text-base font-semibold">(Nível E)</p>
                            </div><div className="flex items-center justify-center flex-col gap-1 md:pb-1 order-4 md:order-2">

                                <p className="font-poppins text-white text-base font-semibold">(Nível D)</p>
                            </div><div className="flex items-center justify-center flex-col gap-1 md:pb-1 order-3">

                                <p className="font-poppins text-white text-base font-semibold">(Nível C)</p>
                            </div><div className="flex items-center justify-center flex-col gap-1 md:pb-1 order-2 md:order-4">

                                <p className="font-poppins text-white text-base font-semibold">(Nível B)</p>
                            </div><div className="flex items-center justify-center flex-col gap-1 md:pb-1 order-1 md:order-5">

                                <p className="font-poppins text-white text-base font-semibold">(Nível A)</p>
                            </div></>
                    )}
                </div>

                <div className="grid md:col-span-5 bg-white rounded-xl md:mt-2">
                    <div className="grid grid-cols-0 grid-rows-5 md:grid-rows-none md:grid-cols-5 gap-1 p-1.5 text-center font-poppins text-gray-900 text-base font-semibold">
                        {Array.isArray(pontuacaoGeral) ? (pontuacaoGeral.map((pontuacao, index) => (
                            <div key={index} className={`p-2.5 flex items-center justify-center order-${pontuacaoGeral.length - index} md:order-${index + 1} bg-nivel-${pontuacao.nivel}`}>
                                <p className="leading-none py-1.5">(Nível {pontuacao.nivel})</p>
                            </div>
                        ))

                        ) : (<>

                            <div className="bg-nivel-E p-2.5 flex items-center justify-center order-5 md:order-1">
                                <p className="leading-none py-1.5">(Nível E)</p>
                            </div>
                            <div className="bg-nivel-D p-2.5 flex items-center justify-center order-4 md:order-2">
                                <p className="leading-none py-1.5">(Nível D)</p>
                            </div>
                            <div className="bg-nivel-C p-2.5 flex items-center justify-center order-3">
                                <p className="leading-none py-1.5">(Nível C)</p>
                            </div>
                            <div className="bg-nivel-B p-2.5 flex items-center justify-center order-2 md:order-4">
                                <p className="leading-none py-1.5">(Nível B)</p>
                            </div>
                            <div className="bg-nivel-A p-2.5 flex items-center justify-center order-1 md:order-5">
                                <p className="leading-none py-1.5">(Nível A)</p>
                            </div></>
                        )}
                    </div>
                </div>

                <div className="grid md:col-span-5 grid-cols-none md:grid-cols-5 grid-rows-5 md:grid-rows-none ml-1 md:ml-0">

                    {nivelRealizado === nivelProjetado ? (
                        <div className={`nivel-${formataNivelLowerCase(nivelRealizado)}`}>
                            <div className="text-center md:mt-2 flex items-center justify-center md:block">
                                <img src={up} alt="Seta para cima" className="w-6 rotate-[270deg] md:rotate-0 inline-block max-w-full object-contain mr-2 md:mr-0" />
                                <div>
                                    <p className="leading-none md:mt-2.5 text-base md:text-xl">Realizado - Projetado</p>
                                    <p className="text-sm md:text-base sm:text-sm leading-none">({pontuacaoRealizada} pontos - {pontuacaoProjetada} pontos)</p>
                                </div>
                            </div>
                        </div>
                    ) : (
                        <>

                            <div className={`nivel-${formataNivelLowerCase(nivelRealizado)}`}>
                                <div className="text-center md:mt-2 flex items-center justify-center md:block">
                                    <img src={up} alt="Seta para cima" className="w-6 rotate-[270deg] md:rotate-0 inline-block max-w-full object-contain mr-2 md:mr-0" />
                                    <div>
                                        <p className="leading-none md:mt-2.5 text-base md:text-xl">Realizado</p>
                                        <p className="text-sm md:text-base lg:text-lg leading-none">({pontuacaoRealizada} pontos)</p>
                                    </div>
                                </div>
                            </div>
                            <div className={`nivel-${formataNivelLowerCase(nivelProjetado)}`}>
                                <div className="text-center md:mt-2 flex items-center justify-center md:block">
                                    <img src={up} alt="Seta para cima" className="w-6 rotate-[270deg] md:rotate-0 inline-block max-w-full object-contain mr-2 md:mr-0" />
                                    <div>
                                        <p className="leading-none md:mt-2.5 text-base md:text-xl">Projetado</p>
                                        <p className="text-sm md:text-base sm:text-sm leading-none">({pontuacaoProjetada} pontos)</p>
                                    </div>
                                </div>
                            </div>
                        </>
                    )}
                </div>
            </div>
        </div>
    )
}

export default DesempenhoGeralUsuario